// extracted by mini-css-extract-plugin
export default {"colorGroup":"BorderColorInput_colorGroup__5MdnF","colorSwatch":"BorderColorInput_colorSwatch__KwHne","colorInput":"BorderColorInput_colorInput__myJPu"};